import { PageViewportLayout } from "shared/components/template"
import { Outer } from "../explore/styles"
import { FlexBox, useToasts } from "@brg/ui"
import { ProjectEditPageGridLabel } from "../projectEdit/styles"
import { Input } from "@brg/input"
import { API, Endpoints, ProjectAPI, Project, Lang, UploadFileAPI, S } from "@brg/api"
import { useEffect, useMemo, useRef, useState, useCallback } from "react"
import { useProfile } from "@brg/auth"
import { CreateLinkTo } from "shared/constants/linkTo"
import { useHistory } from "react-router-dom"
import { createEmptyLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Empty"
import { VoteEditFrameCreating } from "shared/components/error-frames/vote-edit-frame"
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { useTranslation } from "react-i18next"
import { MAX_FILE_SIZE } from "../projectEdit/constants"
import { setProjectTitleByLang } from "../projectEdit/helpers"
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults"
import LeftSide from "../projectEdit/LeftSide"
import { useSimpleUploader } from "@brg/uploader"
import styled from "styled-components"
import {useGetPollByParentEntity} from "../../hooks/api/useGetPollByParentEntity";
import { Voidable } from "@brg/toolbox"

const PUBLISHED_STATUS = 1;
export const SP_VOTE_COLLECTION_SIGN= 'super-puper-collection';

const InputsWrapper = styled(FlexBox)`

input[type="time"]::-webkit-calendar-picker-indicator {
  color-scheme: dark;
}
.time-input {
  padding-left: 16px;
  padding-right: 16px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: rgba(254,254,254,1);
  -webkit-transition: border 0.2s;
  transition: border 0.2s;
  padding-top: 16px;
  padding-bottom: 13px;
  height: 48px !important;
  box-sizing: border-box;
  outline: none !important;
  width: 100%;
  background: #30363A;
  width: 100%;
  border-radius: 3px;
  border: 1px solid #30363A;
  background: #30363A;
}
`;

export const VotesAdminPage = () => {
    const profile = useProfile();
    const history = useHistory();
    const toasts = useToasts();
    const { t, i18n } = useTranslation();

    const langRef = useRef<any>(null);
    const projectIdRef = useRef<any>(null);
    const bilingualRef = useRef<any>(null);
    const sipRef = useRef<any>(null);
    const sipRefEn = useRef<any>(null);

    const [project, setProject] = useState(null);
    const [projectId, setProjectId] = useState('');
    const [collectionId, setCollectionId] = useState('');
    const [autoVoteCount , setAutoVoteCount] = useState('');
    const [voteName, setVoteName] = useState<LangObject[]>(createDefaultLangObject(''));
    const [collectionType, setCollectionType] = useState<{ label: string; value: string; }>();

    const [voteDelay, setVoteDelay] = useState<any>({
      hours: 0,
      minutes: 0,
      seconds: 0
    });
    const [isCreating, setIsCreating] = useState(false);

    projectIdRef.current = projectId;
    //@ts-ignore
    const isBilingual = !!project?.longreadId_en;
    bilingualRef.current = isBilingual;

    const isTitleEmpty = useMemo(() => Lang(voteName, i18n.language) &&  Lang(voteName, i18n.language).trim() === '', [voteName, i18n]);

    const title = useMemo(() => (isTitleEmpty ? '' : Lang(voteName, i18n.language)) , [isTitleEmpty, i18n, voteName])

    const fetchCollectionId = async (projectId: string, collectionId: string) => {
       await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/pools/CreateBestOfByCardCollection')
        .post()
        .body(
          {
            projectId,
            participantQuantity: 0,
            collectionId,
            AutoStageVoteCount: autoVoteCount,
            poolEndDelay: voteDelay,
            collectionType: collectionType?.value
        }
        )
        .send()
        .then((r) => r.json())
    }

    const onCreateProject = () => {
        if (profile) {
            ProjectAPI.Add({
                authorId: profile.accountId,
                seasonId: '',
                competitionId: null,
                title: createEmptyLangObject('', ['En']),
                status: 0,
              } as Project<'Global'> & any)
                .then((res) => res.json())
                .then((res: any) => {
                  setProjectId(res)
                  return res;
                })
                .then((res) => {
                  ProjectAPI.Get({ idProject: res})
                  .then((r) => r.json() as Promise<Project<'Global'> & { creatorId: string }>)
                  .then((r) => {
                    //@ts-ignore
                      setProject(r)
                })})
                
        }
    }

    useEffect(() => {
        if (profile && projectId === '') {
        onCreateProject()
      }
    }, [profile])

    const onCreateCollectionVote = () => {
      if (profile && collectionId && projectId) {
        setIsCreating(true);
        fetchCollectionId(projectId, collectionId) // Заменяем дефолтный лонгрид на лонгрид с коллекцией
        .then(() => {
          //@ts-ignore
            ProjectAPI.Update({...project, contexts: [SP_VOTE_COLLECTION_SIGN], title: voteName }) // обновляем
            .then((r) => {
                if (r.status === 200) {
                    setTimeout(() => {
                      ProjectAPI.UpdateStatus({ // Обновляем статус
                        projectStatus: PUBLISHED_STATUS,
                        projectId,
                      })
                      .then(() => {
                        setIsCreating(false)
                        history.replace(CreateLinkTo.project(projectId));
                      })
                    }, 1500);
                }
            })
        })
      }
    }

    const onTitleChange = (value: string) => {
        setVoteName(setProjectTitleByLang(bilingualRef.current, voteName, i18n.language, value))
      };

      const uploadValidator = useCallback(async (files: any) => {
        let failedChecks: {
          dimensions?: boolean;
          size?: boolean;
          ratio?: boolean;
          type?: boolean;
        } = {};
        const loadFile = () => new Promise((resolve, reject) => {
          const fr = new FileReader();
          fr.onload = function () { // file is loaded
            const img = new Image();
    
            img.onload = function () {
              const {
                width,
                height,
              } = img;
              resolve({
                width,
                height,
              })
            };
    
            //@ts-ignore
            img.src = fr.result; // is the data URL because called with readAsDataURL
          };
          fr.readAsDataURL(files[0]);
        })
    
        //@ts-ignore
        const { height, width } = await loadFile();
    
        if (height > 5262 || width > 3720) {
          toasts.error(t('project_edit.image_error.max_width_height'));
          failedChecks.dimensions = true;
        }
    
    
        const ratio = width / height;
        if (ratio < 0.6 || ratio > 0.8) {
          toasts.error(t('project_edit.image_error.wrong_orientation'));
          failedChecks.ratio = true;
        }
    
        if (files?.[0]?.size > MAX_FILE_SIZE) {
          toasts.error(t('project_edit.image_error.max_size'));
          failedChecks.size = true;
        }
    
        if (!['image/jpeg'].includes(files?.[0]?.type)) {
          toasts.error(t('project_edit.image_error.wrong_format'));
          failedChecks.size = true;
        }
    
        const {
          size: failedSize,
          dimensions: failedDimensions,
          ratio: failedRatio,
        } = failedChecks;
    
        if (failedSize || failedDimensions || failedRatio) {
          sipRef.current.uploader.inputRef.current.value = '';
          sipRefEn.current.uploader.inputRef.current.value = '';
    
          return false;
        }
    
        return true;
      }, [t]);

      const uploaderCallback = useCallback((fileId: Voidable<string>) => {
        if (!fileId) {
          return null;
        }
    
        UploadFileAPI.Upload({
          fileId,
          profileId: projectIdRef.current,
          service: 'geography',
          entityType: 'projectimage',
          localization: langRef.current,
        }).then((res) => {
          sipRef?.current?.uploader?.uploader?.uppy?.reset();
          sipRefEn?.current?.uploader?.uploader?.uppy?.reset();
          return res;
        });
      }, [projectIdRef])

      const sip = useSimpleUploader(uploaderCallback, uploadValidator);
      const sip_en = useSimpleUploader(uploaderCallback, uploadValidator);

      const disableSubmit = useMemo(
        () => (!(collectionId !== '' && autoVoteCount !== '' && !!title?.length && voteDelay !== '0' ))
        , [collectionId, title,autoVoteCount, isTitleEmpty, voteDelay]
      )

      const localized_sip = i18n.language === 'en' ? sip_en : sip
      langRef.current = i18n.language;
    

    if (isCreating || !project) {
        return (
            <VoteEditFrameCreating id={collectionId} />
        )
    }

    const handleVoteDelayChange = ({ target }: any) => {
        const time = target.value?.split(':');
        
        if (time?.length === 2) {
          const [hours, minutes] = time?.map((i: string) => parseFloat(i));

          setVoteDelay({
            ...voteDelay,
            hours,
            minutes
          })
        }}

        const ContextsOptions: {
          label: string;
          value: string;
        }[] = [
          { label: "глобальный музей", value: "museum" },
          { label: "коллекция", value: "collection" },
          { label: "личный музей", value: "private_collection" },
          { label: "личная подколлекция", value: "private_subcollection" }
        ];
        

    return (
        <PageViewportLayout>
            <Outer>
                <InputsWrapper direction="column" gy={20} gyMobile={20}>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'collection id'}</ProjectEditPageGridLabel>
                        <Input.Text value={collectionId} placeholder="collection id" onChange={(ev: any) => setCollectionId(ev.target.value)}/>
                    </FlexBox>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'collection type'}</ProjectEditPageGridLabel>
                        <Input.Dropdown 
                          options={ContextsOptions}
                          placeholder={'select collection type'}
                          value={collectionType}
                          onChange={(item: any) => setCollectionType(item)}
                        
                        /*value={collectionId} placeholder="collection type"*/ /> 
                    </FlexBox>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'AutoStageVoteCount'}</ProjectEditPageGridLabel>
                        <Input.Text value={autoVoteCount} placeholder="AutoStageVoteCount" onChange={(ev: any) => setAutoVoteCount(ev.target.value)}/>
                    </FlexBox>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'Vote delay'}</ProjectEditPageGridLabel>
                        {/* <Input.Text value={voteDelay} placeholder="Vote delay" onChange={(ev: any) => setVoteDelay(ev.target.value)}/> */}
                        <input className={'time-input'} type={'time'} onChange={handleVoteDelayChange} />
                    </FlexBox>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'Name of the vote'}</ProjectEditPageGridLabel>
                        <Input.Text value={title} placeholder="Name of the vote" onChange={(ev: any) => onTitleChange(ev.target.value)}/>
                    </FlexBox>
                    {/* {project && (
                       <FlexBox>
                        <ProjectEditPageGridLabel>{'Vote cover'}</ProjectEditPageGridLabel>
                        <LeftSide 
                        //@ts-ignore
                          project={project}
                          //@ts-ignore
                          fileInput={localized_sip}
                          isProjectEdit
                        />
                      </FlexBox>
                    )} */}
                   
                    <FlexBox>
                        <button onClick={onCreateCollectionVote} disabled={disableSubmit}>Create</button>
                    </FlexBox>
                </InputsWrapper>
            </Outer>
        </PageViewportLayout>
    )
}import { PageViewportLayout } from "shared/components/template"
import { Outer } from "../explore/styles"
import { FlexBox, useToasts } from "@brg/ui"
import { ProjectEditPageGridLabel } from "../projectEdit/styles"
import { Input } from "@brg/input"
import { API, Endpoints, ProjectAPI, Project, Lang, UploadFileAPI, S } from "@brg/api"
import { useEffect, useMemo, useRef, useState, useCallback } from "react"
import { useProfile } from "@brg/auth"
import { CreateLinkTo } from "shared/constants/linkTo"
import { useHistory } from "react-router-dom"
import { createEmptyLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Empty"
import { VoteEditFrameCreating } from "shared/components/error-frames/vote-edit-frame"
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import { useTranslation } from "react-i18next"
import { MAX_FILE_SIZE } from "../projectEdit/constants"
import { setProjectTitleByLang } from "../projectEdit/helpers"
import { createDefaultLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Defaults"
import LeftSide from "../projectEdit/LeftSide"
import { useSimpleUploader } from "@brg/uploader"
import styled from "styled-components"
import {useGetPollByParentEntity} from "../../hooks/api/useGetPollByParentEntity";
import { Voidable } from "@brg/toolbox"

const PUBLISHED_STATUS = 1;
export const SP_VOTE_COLLECTION_SIGN= 'super-puper-collection';

const InputsWrapper = styled(FlexBox)`

input[type="time"]::-webkit-calendar-picker-indicator {
  color-scheme: dark;
}
.time-input {
  padding-left: 16px;
  padding-right: 16px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: rgba(254,254,254,1);
  -webkit-transition: border 0.2s;
  transition: border 0.2s;
  padding-top: 16px;
  padding-bottom: 13px;
  height: 48px !important;
  box-sizing: border-box;
  outline: none !important;
  width: 100%;
  background: #30363A;
  width: 100%;
  border-radius: 3px;
  border: 1px solid #30363A;
  background: #30363A;
}
`;

export const VotesAdminPage = () => {
    const profile = useProfile();
    const history = useHistory();
    const toasts = useToasts();
    const { t, i18n } = useTranslation();

    const langRef = useRef<any>(null);
    const projectIdRef = useRef<any>(null);
    const bilingualRef = useRef<any>(null);
    const sipRef = useRef<any>(null);
    const sipRefEn = useRef<any>(null);

    const [project, setProject] = useState(null);
    const [projectId, setProjectId] = useState('');
    const [collectionId, setCollectionId] = useState('');
    const [autoVoteCount , setAutoVoteCount] = useState('');
    const [voteName, setVoteName] = useState<LangObject[]>(createDefaultLangObject(''));
    const [collectionType, setCollectionType] = useState<{ label: string; value: string; }>();

    const [voteDelay, setVoteDelay] = useState<any>({
      hours: 0,
      minutes: 0,
      seconds: 0
    });
    const [isCreating, setIsCreating] = useState(false);

    projectIdRef.current = projectId;
    //@ts-ignore
    const isBilingual = !!project?.longreadId_en;
    bilingualRef.current = isBilingual;

    const isTitleEmpty = useMemo(() => Lang(voteName, i18n.language) &&  Lang(voteName, i18n.language).trim() === '', [voteName, i18n]);

    const title = useMemo(() => (isTitleEmpty ? '' : Lang(voteName, i18n.language)) , [isTitleEmpty, i18n, voteName])

    const fetchCollectionId = async (projectId: string, collectionId: string) => {
       await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/pools/CreateBestOfByCardCollection')
        .post()
        .body(
          {
            projectId,
            participantQuantity: 0,
            collectionId,
            AutoStageVoteCount: autoVoteCount,
            poolEndDelay: voteDelay,
            collectionType: collectionType?.value
        }
        )
        .send()
        .then((r) => r.json())
    }

    const onCreateProject = () => {
        if (profile) {
            ProjectAPI.Add({
                authorId: profile.accountId,
                seasonId: '',
                competitionId: null,
                title: createEmptyLangObject('', ['En']),
                status: 0,
              } as Project<'Global'> & any)
                .then((res) => res.json())
                .then((res: any) => {
                  setProjectId(res)
                  return res;
                })
                .then((res) => {
                  ProjectAPI.Get({ idProject: res})
                  .then((r) => r.json() as Promise<Project<'Global'> & { creatorId: string }>)
                  .then((r) => {
                    //@ts-ignore
                      setProject(r)
                })})
                
        }
    }

    useEffect(() => {
        if (profile && projectId === '') {
        onCreateProject()
      }
    }, [profile])

    const onCreateCollectionVote = () => {
      if (profile && collectionId && projectId) {
        setIsCreating(true);
        fetchCollectionId(projectId, collectionId) // Заменяем дефолтный лонгрид на лонгрид с коллекцией
        .then(() => {
          //@ts-ignore
            ProjectAPI.Update({...project, contexts: [SP_VOTE_COLLECTION_SIGN], title: voteName }) // обновляем
            .then((r) => {
                if (r.status === 200) {
                    setTimeout(() => {
                      ProjectAPI.UpdateStatus({ // Обновляем статус
                        projectStatus: PUBLISHED_STATUS,
                        projectId,
                      })
                      .then(() => {
                        setIsCreating(false)
                        history.replace(CreateLinkTo.project(projectId));
                      })
                    }, 1500);
                }
            })
        })
      }
    }

    const onTitleChange = (value: string) => {
        setVoteName(setProjectTitleByLang(bilingualRef.current, voteName, i18n.language, value))
      };

      const uploadValidator = useCallback(async (files: any) => {
        let failedChecks: {
          dimensions?: boolean;
          size?: boolean;
          ratio?: boolean;
          type?: boolean;
        } = {};
        const loadFile = () => new Promise((resolve, reject) => {
          const fr = new FileReader();
          fr.onload = function () { // file is loaded
            const img = new Image();
    
            img.onload = function () {
              const {
                width,
                height,
              } = img;
              resolve({
                width,
                height,
              })
            };
    
            //@ts-ignore
            img.src = fr.result; // is the data URL because called with readAsDataURL
          };
          fr.readAsDataURL(files[0]);
        })
    
        //@ts-ignore
        const { height, width } = await loadFile();
    
        if (height > 5262 || width > 3720) {
          toasts.error(t('project_edit.image_error.max_width_height'));
          failedChecks.dimensions = true;
        }
    
    
        const ratio = width / height;
        if (ratio < 0.6 || ratio > 0.8) {
          toasts.error(t('project_edit.image_error.wrong_orientation'));
          failedChecks.ratio = true;
        }
    
        if (files?.[0]?.size > MAX_FILE_SIZE) {
          toasts.error(t('project_edit.image_error.max_size'));
          failedChecks.size = true;
        }
    
        if (!['image/jpeg'].includes(files?.[0]?.type)) {
          toasts.error(t('project_edit.image_error.wrong_format'));
          failedChecks.size = true;
        }
    
        const {
          size: failedSize,
          dimensions: failedDimensions,
          ratio: failedRatio,
        } = failedChecks;
    
        if (failedSize || failedDimensions || failedRatio) {
          sipRef.current.uploader.inputRef.current.value = '';
          sipRefEn.current.uploader.inputRef.current.value = '';
    
          return false;
        }
    
        return true;
      }, [t]);

      const uploaderCallback = useCallback((fileId: Voidable<string>) => {
        if (!fileId) {
          return null;
        }
    
        UploadFileAPI.Upload({
          fileId,
          profileId: projectIdRef.current,
          service: 'geography',
          entityType: 'projectimage',
          localization: langRef.current,
        }).then((res) => {
          sipRef?.current?.uploader?.uploader?.uppy?.reset();
          sipRefEn?.current?.uploader?.uploader?.uppy?.reset();
          return res;
        });
      }, [projectIdRef])

      const sip = useSimpleUploader(uploaderCallback, uploadValidator);
      const sip_en = useSimpleUploader(uploaderCallback, uploadValidator);

      const disableSubmit = useMemo(
        () => (!(collectionId !== '' && autoVoteCount !== '' && !!title?.length && voteDelay !== '0' ))
        , [collectionId, title,autoVoteCount, isTitleEmpty, voteDelay]
      )

      const localized_sip = i18n.language === 'en' ? sip_en : sip
      langRef.current = i18n.language;
    

    if (isCreating || !project) {
        return (
            <VoteEditFrameCreating id={collectionId} />
        )
    }

    const handleVoteDelayChange = ({ target }: any) => {
        const time = target.value?.split(':');
        
        if (time?.length === 2) {
          const [hours, minutes] = time?.map((i: string) => parseFloat(i));

          setVoteDelay({
            ...voteDelay,
            hours,
            minutes
          })
        }}

        const ContextsOptions: {
          label: string;
          value: string;
        }[] = [
          { label: "глобальный музей", value: "museum" },
          { label: "коллекция", value: "collection" },
          { label: "личный музей", value: "private_collection" },
          { label: "личная подколлекция", value: "private_subcollection" }
        ];
        

    return (
        <PageViewportLayout>
            <Outer>
                <InputsWrapper direction="column" gy={20} gyMobile={20}>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'collection id'}</ProjectEditPageGridLabel>
                        <Input.Text value={collectionId} placeholder="collection id" onChange={(ev: any) => setCollectionId(ev.target.value)}/>
                    </FlexBox>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'collection type'}</ProjectEditPageGridLabel>
                        <Input.Dropdown 
                          options={ContextsOptions}
                          placeholder={'select collection type'}
                          value={collectionType}
                          onChange={(item: any) => setCollectionType(item)}
                        
                        /*value={collectionId} placeholder="collection type"*/ /> 
                    </FlexBox>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'AutoStageVoteCount'}</ProjectEditPageGridLabel>
                        <Input.Text value={autoVoteCount} placeholder="AutoStageVoteCount" onChange={(ev: any) => setAutoVoteCount(ev.target.value)}/>
                    </FlexBox>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'Vote delay'}</ProjectEditPageGridLabel>
                        {/* <Input.Text value={voteDelay} placeholder="Vote delay" onChange={(ev: any) => setVoteDelay(ev.target.value)}/> */}
                        <input className={'time-input'} type={'time'} onChange={handleVoteDelayChange} />
                    </FlexBox>
                    <FlexBox>
                        <ProjectEditPageGridLabel>{'Name of the vote'}</ProjectEditPageGridLabel>
                        <Input.Text value={title} placeholder="Name of the vote" onChange={(ev: any) => onTitleChange(ev.target.value)}/>
                    </FlexBox>
                    {/* {project && (
                       <FlexBox>
                        <ProjectEditPageGridLabel>{'Vote cover'}</ProjectEditPageGridLabel>
                        <LeftSide 
                        //@ts-ignore
                          project={project}
                          //@ts-ignore
                          fileInput={localized_sip}
                          isProjectEdit
                        />
                      </FlexBox>
                    )} */}
                   
                    <FlexBox>
                        <button onClick={onCreateCollectionVote} disabled={disableSubmit}>Create</button>
                    </FlexBox>
                </InputsWrapper>
            </Outer>
        </PageViewportLayout>
    )
}